import { render } from "./service.vue?vue&type=template&id=18a73c78&scoped=true"
import script from "./service.vue?vue&type=script&lang=js"
export * from "./service.vue?vue&type=script&lang=js"

import "./service.vue?vue&type=style&index=0&id=18a73c78&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-18a73c78"

export default script